import React from 'react';
import { theme } from './theme';
import { feedbackUrl } from './feedbackLink';

// Footer shown on every signed-in screen. The sign-in and sign-up page
// carries its own legal line, so it does not render this.
const link = { color: '#CFDBE8', textDecoration: 'none', margin: '0 8px' };

export function PinLogo({ h = 28 }) {
  return (
    <svg width={h * 0.75} height={h} viewBox="0 0 24 32" aria-hidden="true">
      <path d="M12 0C5.4 0 0 5.2 0 11.7C0 20.5 12 32 12 32S24 20.5 24 11.7C24 5.2 18.6 0 12 0Z" fill="#F4C11C" />
      <circle cx="12" cy="11.7" r="7.4" fill="#1E3A5F" />
      <path d="M8.4 11.9l2.7 2.7 4.7-5.6" fill="none" stroke="#F4C11C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function AppFooter({ flush }) {
  const year = new Date().getFullYear();
  return (
    <footer
      style={{
        background: '#1E3A5F', color: '#CFDBE8', padding: flush ? '26px 40px' : '26px 24px', fontSize: '13px',
        lineHeight: 1.7, fontFamily: theme.fontBody || 'inherit', marginTop: flush ? 0 : '40px',
      }}
    >
      <div style={{ maxWidth: flush ? 'none' : '1032px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '18px 30px', justifyContent: 'space-between' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 800, color: '#fff', fontSize: '15px' }}><PinLogo h={22} />FlyAtlast</div>
          <div style={{ fontWeight: 700, color: '#fff' }}>Pin. Track. Fly.</div>
          <div style={{ maxWidth: '330px', marginTop: '10px', fontSize: '12.5px', lineHeight: 1.55 }}>&copy; {year} FlyAtlast. FlyAtlast is a business name of 2658023 Ontario Inc., Canada.</div>
        </div>
        <div className="app-ft-r">
          <nav aria-label="Footer">
            <a style={link} href="https://flyatlast.com/terms.html" target="_blank" rel="noopener noreferrer">Terms</a>
            <a style={link} href="https://flyatlast.com/privacy.html" target="_blank" rel="noopener noreferrer">Privacy</a>
            <a style={link} href={feedbackUrl()} target="_blank" rel="noopener noreferrer">Feedback</a>
            <a style={{ ...link, marginRight: 0 }} href="mailto:contactus@flyatlast.com">Contact</a>
          </nav>
          <div>contactus@flyatlast.com</div>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;
